// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal.css */
/* Using your app's established styles for modals and forms */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background-color: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}
.modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #9ca3af;
  cursor: pointer;
}
.modal-body {
  padding: 24px;
}
.form-group label {
  margin-bottom: 8px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  display: block;
}
.form-group input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f9fafb;
  font-size: 14px;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background-color: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 12px 12px;
}
.btn {
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
}
.btn-secondary {
  background-color: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
}
.btn-primary {
  background-color: #f97316;
  color: white;
}
.btn:disabled {
  background-color: #fdba74;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE,6DAA6D;AAC7D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* src/compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal.css */\n/* Using your app's established styles for modals and forms */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(17, 24, 39, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.modal-content {\n  background-color: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n.modal-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #9ca3af;\n  cursor: pointer;\n}\n.modal-body {\n  padding: 24px;\n}\n.form-group label {\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n  display: block;\n}\n.form-group input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #f9fafb;\n  font-size: 14px;\n}\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  background-color: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  border-radius: 0 0 12px 12px;\n}\n.btn {\n  border: none;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.btn-secondary {\n  background-color: #fff;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n.btn-primary {\n  background-color: #f97316;\n  color: white;\n}\n.btn:disabled {\n  background-color: #fdba74;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
